// T-462 — "Controllo prezzi": card che mostra i costi anomali rilevati da
// detectCostAnomalies (unità miste, costo in unità sbagliata, costo/pezzo alto,
// salto vs storico, outlier di categoria). Il tap apre il documento già
// collegato al costo; la correzione manuale è deliberatamente separata.
import { IonIcon } from '@ionic/react';
import { alertCircleOutline, chevronForwardOutline } from 'ionicons/icons';
import type { CostAnomaly } from '@trackeat/shared';

const SEV: Record<CostAnomaly['severity'], { dot: string; label: string }> = {
  alta: { dot: '#dc2626', label: 'Alta' },
  media: { dot: '#d97706', label: 'Media' },
  bassa: { dot: '#ca8a04', label: 'Bassa' },
};

export function FoodCostAnomalyCard({ anomalies, onOpenDocument, onManualFix }: {
  anomalies: CostAnomaly[];
  onOpenDocument: (foodId: string) => void;
  onManualFix: (foodId: string) => void;
}): JSX.Element | null {
  if (anomalies.length === 0) return null;
  return (
    <div style={{
      margin: '12px 14px 0', borderRadius: 12, overflow: 'hidden',
      border: '1px solid #fecaca', background: '#fff',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px',
        background: '#fef2f2', borderBottom: '1px solid #fecaca',
      }}>
        <IonIcon icon={alertCircleOutline} style={{ color: '#dc2626', fontSize: 18 }} />
        <div style={{ fontWeight: 700, color: '#991b1b', fontSize: 14 }}>
          Controllo prezzi — {anomalies.length} {anomalies.length === 1 ? 'costo da verificare' : 'costi da verificare'}
        </div>
      </div>
      <div style={{ padding: '2px 0' }}>
        {anomalies.map((a) => (
          <div key={`${a.foodId}:${a.kind}`} style={{ borderTop: '1px solid #f1f5f9' }}>
            <button
              onClick={() => onOpenDocument(a.foodId)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                padding: '9px 12px', background: 'none', border: 'none',
                textAlign: 'left', cursor: 'pointer',
              }}
            >
              <span aria-hidden style={{ width: 9, height: 9, borderRadius: 5, background: SEV[a.severity].dot, flex: '0 0 auto' }} />
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: 'block', fontWeight: 600, color: '#0f172a', fontSize: 14 }}>
                  {a.name}
                  {a.currentCost != null && (
                    <span style={{ fontWeight: 400, color: '#475569' }}> · {a.currentCost.toLocaleString('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 4 })}/{a.currentUom ?? '?'}</span>
                  )}
                </span>
                <span style={{ display: 'block', fontSize: 14, color: '#475569', lineHeight: 1.5 }}>{a.detail}</span>
              </span>
              <IonIcon icon={chevronForwardOutline} style={{ color: '#cbd5e1', fontSize: 16, flex: '0 0 auto' }} />
            </button>
            <button type="button" onClick={() => onManualFix(a.foodId)} style={{ margin: '0 12px 9px 31px', border: 'none', background: 'none', color: '#475569', fontSize: 14, padding: 0, textDecoration: 'underline' }}>
              Correggi costo manualmente
            </button>
          </div>
        ))}
      </div>
      <div style={{ padding: '8px 12px', fontSize: 11, color: '#94a3b8', borderTop: '1px solid #f1f5f9' }}>
        Tocca un prodotto per aprire il documento da cui proviene il costo. Non serve ricaricarlo.
      </div>
    </div>
  );
}
